import axios from "axios";
import Vue from "vue";
export const state = {
  getSpecificStudents: [],
  classTeaches: [],
  schoolYears: [],
  marksFilters: {},
  currentClass: {},
  currentSub: {},
  currentSet: {},
  allMarks: [],
  setMarks: [],
  subMarks: [],
  specMarks: [],
  save_status: false,
  fetchingReports: false,
  reportDetails: [],
  commentDetails: [],
  progressMarks: [],
  passMark: [],
  studentReport: {},
  studentReportLink: {},
  marksheet: [],
  divisions: [],
  subanalysis: [],
  progDetails: [],
  allStdProgMarks: [],
  testResults: [],
};
export const getters = {
  getSpecificStudents: (state) => state.getSpecificStudents.data,
  getClassTeaches: (state) => state.classTeaches.data,
  getYears: (state) => state.schoolYears.data,
  getMarksFilters: (state) => state.marksFilters,
  getAllMarksFilters: (state) => state.allMarks.data,
  getSetMarksFilters: (state) => state.setMarks.data,
  getSubMarksFilters: (state) => state.subMarks.data,
  getCurrentClass: (state) => state.currentClass,
  getCurrentSet: (state) => state.currentSet,
  getSpecMarksFilters: (state) => state.specMarks.data,
  getCurrentSub: (state) => state.currentSub,
  SaveStatus: (state) => state.save_status,
  getReportDetails: (state) => state.reportDetails,
  getCommentDetails: (state) => state.commentDetails,
  getFechingReports: (state) => state.fetchingReports,
  getProgressMarks: (state) => state.progressMarks.data,
  getPassMark: (state) => state.passMark.data,
  getStudentReport: (state) => state.studentReport.data,
  getStudentReportLink: (state) => state.studentReportLink.data,
  getFilteredMarkSheet: (state) => state.marksheet.data,
  getFilteredDivision: (state) => state.divisions.data,
  getSubjectAnalysis: (state) => state.subanalysis.data,
  getProgDetails: (state) => state.allStdProgMarks.data,
  getTestResult: (state) => state.testResults.data,
};

export const mutations = {
  SET_SPEC_STD(state, newValue) {
    state.getSpecificStudents = newValue;
  },
  SET_SCH_YEARS(state, newValue) {
    state.schoolYears = newValue;
  },
  SET_SAVE_STATUS(state, newValue) {
    state.save_status = newValue;
  },
  SET_MARKS_FILTERS(state, newValue) {
    state.marksFilters = newValue;
  },
  SET_CLASS_TEACHES(state, newValue) {
    state.classTeaches = newValue;
  },
  SET_ALLMARKS(state, newValue) {
    state.allMarks = newValue;
  },
  SET_SETMARKS(state, newValue) {
    state.setMarks = newValue;
  },
  SET_CURRENTCLASS(state, newValue) {
    state.currentClass = newValue;
  },
  SET_CURRENTSUB(state, newValue) {
    state.currentSub = newValue;
  },
  SET_CURRENTSET(state, newValue) {
    state.currentSet = newValue;
  },
  SET_SUBMARKS(state, newValue) {
    state.subMarks = newValue;
  },
  SET_SPECMARKS(state, newValue) {
    state.specMarks = newValue;
  },
  SET_REPORT_DATA(state, newValue) {
    state.reportDetails = newValue;
  },
  SET_STD_REPORT_DATA(state, newValue) {
    state.studentReportLink = newValue;
  },
  SET_STUDENT_REPORT(state, newValue) {
    state.studentReport = newValue;
  },
  SET_COMMENT_DATA(state, newValue) {
    state.commentDetails = newValue;
  },
  SET_FETCHING_REPORT_DATA(state, newValue) {
    state.fetchingReports = newValue;
  },
  SET_PASS_MARK(state, newValue) {
    state.passMark = newValue;
  },
  SET_PROGRESS_MARKS(state, newValue) {
    state.progressMarks = newValue;
  },
  SET_MARKSHEET(state, newValue) {
    state.marksheet = newValue;
  },
  SET_DIVISION(state, newValue) {
    state.divisions = newValue;
  },
  SET_SUBANALYSIS(state, newValue) {
    state.subanalysis = newValue;
  },
  SET_TESTRESULTS(state, newValue) {
    state.testResults = newValue;
  },
  SET_ALL_STD_MARKS(state, newValue) {
    state.allStdProgMarks = newValue;
  },
  pushNotification(state, payload) {
    Vue.notify({
      type: payload.type,
      group: "foo",
      title: payload.title,
      text: payload.message,
      position: "bottom right",
      duration: 10000,
      speed: 500,
    });
  },
};

export const actions = {
  //fetch years
  fetchYear({ commit }) {
    // commit('SET_SAVE_STATUS', true);
    axios
      .get(`fetch/years`)
      .then((response) => {
        commit("SET_SCH_YEARS", response.data);
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        commit("SET_SAVE_STATUS", false);
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occurred in Fetching Years",
        };
        commit("pushNotification", message);
      });
  },

  //fetch specific std
  fetchSpecificStd({ commit }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post(`exams/marks`, payload)
      .then((response) => {
        //request the for data again after marks addition.
        // response.data.data.reloadStatus == 1
        //   ? dispatch("refetchSpecificStd", payload)
        //   : null;
        commit("SET_SPEC_STD", response.data);
        //setting up filters
        commit("SET_MARKS_FILTERS", payload);
      })
      .catch(() => {
        commit("SET_SAVE_STATUS", false);
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occurred While Saving",
        };
        commit("pushNotification", message);
      });
  },

  //re fetch specific std
  refetchSpecificStd({ commit }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post(`exams/marks`, payload)
      .then((response) => {
        commit("SET_SPEC_STD", response.data);
        //setting up filters
        commit("SET_MARKS_FILTERS", payload);
      })
      .catch(() => {
        commit("SET_SAVE_STATUS", false);
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occurred While Saving",
        };
        commit("pushNotification", message);
      });
  },

  // Save Marks
  saveMarks({ commit }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post(`marks/add`, payload)
      .then((response) => {
        // dispatch("fetchSpecificStd", payload.marksFilters);
        commit("SET_SPEC_STD", response.data);
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        commit("SET_SAVE_STATUS", false);
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message:
            "An Error Occurred While Saving. <b>Marks Where Not Saved</b>",
        };
        commit("pushNotification", message);
      });
  },

  //add pass mark
  addPassMark({ commit }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post("passmark", payload)
      .then((response) => {
        commit("SET_PASS_MARK", response.data);
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: "Pass Mark Added Successfully",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        commit("SET_SAVE_STATUS", false);
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occurred While Saving. <b>Pass Mark Not Saved</b>",
        };
        commit("pushNotification", message);
      });
  },

  //edit pass mark
  editPassMark({ commit }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .put(`passmark/${payload.id}`, payload)
      .then((response) => {
        commit("SET_PASS_MARK", response.data);
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: "Pass Mark Updated Successfully",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        commit("SET_SAVE_STATUS", false);
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message:
            "An Error Occurred While Saving. <b>Pass Mark Not Updated</b>",
        };
        commit("pushNotification", message);
      });
  },

  //edit pass mark
  deletePassMark({ commit }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .delete(`passmark/${payload.id}`)
      .then((response) => {
        commit("SET_PASS_MARK", response.data);
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: "Pass Mark Deleted Successfully",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        commit("SET_SAVE_STATUS", false);
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message:
            "An Error Occurred While Deleting. <b>Pass Mark Not Delete</b>",
        };
        commit("pushNotification", message);
      });
  },

  // updating students marks
  updateProgressiveMarks({ commit }, payload) {
    const marksObject = payload.progData.marks.find(
      (m) => m.id === payload.enrolId
    );
    if (!marksObject) return;

    if (payload.subjectId != "") {
      // check if subjectId has values for comment
      const classesObject = marksObject.classx;
      if (!classesObject) return;

      const subjectObject = classesObject.subjects.find(
        (s) => s.id === payload.subjectId
      );
      if (!subjectObject) return;

      const criterias = subjectObject.criteria.find(
        (c) => c.id === payload.criteriaId
      );
      if (!criterias) return;

      criterias.marks = payload.newMarks;
    } else {
      // check if criteriaId has values for comment
      if (payload.criteriaId == "tr") {
        marksObject.teacher_cm = payload.newMarks;
      } else {
        marksObject.hm_cm = payload.newMarks;
      }
    }
    axios
      .post(`/marks/update/progressiveMarks`, payload)
      .then((response) => {
        commit("SET_PROGRESS_MARKS", response.data);
        commit("SET_FETCHING_REPORT_DATA", false);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message:
            "An Error Occurred While. <br/><b>Saving Marks Information.</b>",
        };
        commit("pushNotification", message);
        commit("SET_FETCHING_REPORT_DATA", false);
      });
  },

  //fetch pass mark
  fetchResults({ commit }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post(`testResults`, payload)
      .then((response) => {
        commit("SET_TESTRESULTS", response.data);
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        commit("SET_SAVE_STATUS", false);
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occurred <b> While Fetching.</b>",
        };
        commit("pushNotification", message);
      });
  },

  //fetch pass mark
  fetchPassMarks({ commit }) {
    commit("SET_SAVE_STATUS", true);
    axios
      .get(`passmark`)
      .then((response) => {
        commit("SET_PASS_MARK", response.data);
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        commit("SET_SAVE_STATUS", false);
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occurred <b> While Fetching.</b>",
        };
        commit("pushNotification", message);
      });
  },

  //fetching teacher for subject
  fetchClassTeaches({ commit }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post(`class/teacher`, payload)
      .then((response) => {
        commit("SET_CLASS_TEACHES", response.data);
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        commit("SET_SAVE_STATUS", false);
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occurred While. <b>Fetching Teachers</b>",
        };
        commit("pushNotification", message);
      });
  },

  //making all marks filters
  fetchMarksFilters({ commit }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios.post(`marks/allmarks`, payload).then((response) => {
      commit("SET_ALLMARKS", response.data);
      commit("SET_CURRENTCLASS", response.data.class);
      commit("SET_SAVE_STATUS", false);
    });
  },

  //filter marks sheet
  filterMarkSheet({ commit }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios.post(`marks/filterMarkSheet`, payload).then((response) => {
      commit("SET_MARKSHEET", response.data);
      commit("SET_SAVE_STATUS", false);
    });
  },

  //filtering Divisions
  filterDivision({ commit }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios.post(`marks/filterDivision`, payload).then((response) => {
      commit("SET_DIVISION", response.data);
      commit("SET_SAVE_STATUS", false);
    });
  },

  //subject analysis
  filterSubjectAnalysis({ commit }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios.post(`marks/subjectanalysis`, payload).then((response) => {
      commit("SET_SUBANALYSIS", response.data);
      commit("SET_SAVE_STATUS", false);
    });
  },

  //making sets marks filters
  fetchSetsMarksFilters({ commit }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios.post(`marks/setmarks`, payload).then((response) => {
      commit("SET_SAVE_STATUS", false);
      commit("SET_SETMARKS", response.data);
      commit("SET_CURRENTCLASS", response.data.class);
    });
  },

  //making all marks filters
  fetchMarksSubFilters({ commit }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios.post(`marks/subjectmarks`, payload).then((response) => {
      commit("SET_SAVE_STATUS", false);
      commit("SET_SUBMARKS", response.data);
      commit("SET_CURRENTSUB", response.data.subject);
      commit("SET_CURRENTCLASS", response.data.class);
    });
  },

  //making all marks filters
  fetchSpecMarksFilters({ commit }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios.post(`marks/specmarks`, payload).then((response) => {
      commit("SET_SAVE_STATUS", false);
      commit("SET_SPECMARKS", response.data);
      commit("SET_CURRENTSUB", response.data.subject);
      commit("SET_CURRENTCLASS", response.data.class);
      commit("SET_CURRENTSET", response.data.set);
    });
  },

  //fetch marks for reports
  fetchReportDetails({ commit }, payload) {
    commit("SET_FETCHING_REPORT_DATA", true);
    axios
      .post(`marks/getRpeort`, payload)
      .then((response) => {
        commit("SET_REPORT_DATA", response.data);
        commit("SET_FETCHING_REPORT_DATA", false);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message:
            "An Error Occurred While. <br/><b>Please confirm you entered Exam Sets</b>",
        };
        commit("pushNotification", message);
        commit("SET_FETCHING_REPORT_DATA", false);
      });
  },

  //fetch marks for reports
  generateStdReport({ commit }, payload) {
    commit("SET_FETCHING_REPORT_DATA", true);
    axios
      .post(`generateReport`, payload)
      .then((response) => {
        commit("SET_REPORT_DATA", response.data);
        commit("SET_FETCHING_REPORT_DATA", false);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message:
            "An Error Occurred While. <br/><b>Please confirm you entered Exam Sets</b>",
        };
        commit("pushNotification", message);
        commit("SET_FETCHING_REPORT_DATA", false);
      });
  },

  //fetch report for one student.
  fetchStudentReport({ commit }, payload) {
    commit("SET_FETCHING_REPORT_DATA", true);
    axios
      .post(`marks/fetch/studentReport`, payload)
      .then((response) => {
        commit("SET_STUDENT_REPORT", response.data);
        commit("SET_FETCHING_REPORT_DATA", false);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message:
            "An Error Occurred While. <br/><b>Please confirm you entered Exam Sets</b>",
        };
        commit("pushNotification", message);
        commit("SET_FETCHING_REPORT_DATA", false);
      });
  },

  //submitting students comments
  submitStdComment({ commit, dispatch }, payload) {
    axios
      .post("comments/submit", payload)
      .then((response) => {
        commit("SET_SAVE_STATUS", false);
        dispatch("fetchCommentsDetails", payload.filterData);
        console.log(response.data);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message:
            "An Error Occurred While. <br/><b>Savng Student's Comments</b>",
        };
        commit("pushNotification", message);
      });
  },

  addReportInfo({ commit }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post("marks/report_info", payload)
      .then(() => {
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: "School Added Successfully",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message:
            "An Error Occurred While. <br/><b>Savng Report Information.</b>",
        };
        commit("pushNotification", message);
      });
  },

  //fetch marks for reports
  fetchCommentsDetails({ commit }, payload) {
    commit("SET_FETCHING_REPORT_DATA", true);
    axios
      .post(`marks/fetch/commentData`, payload)
      .then((response) => {
        commit("SET_COMMENT_DATA", response.data);
        commit("SET_FETCHING_REPORT_DATA", false);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message:
            "An Error Occurred While. <br/><b>Retrieving Information.</b>",
        };
        commit("pushNotification", message);
        commit("SET_FETCHING_REPORT_DATA", false);
      });
  },

  //Fetch Progressive Marks
  fetchProgressiveMarks({ commit }, payload) {
    commit("SET_FETCHING_REPORT_DATA", true);
    axios
      .post(`marks/fetch/progressiveMarks`, payload)
      .then((response) => {
        commit("SET_PROGRESS_MARKS", response.data);
        commit("SET_FETCHING_REPORT_DATA", false);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message:
            "An Error Occurred While. <br/><b>Retrieving Information.</b>",
        };
        commit("pushNotification", message);
        commit("SET_FETCHING_REPORT_DATA", false);
      });
  },
  //Fetch Student All Progressive Marks
  fetchAllProgDetails({ commit }, payload) {
    commit("SET_FETCHING_REPORT_DATA", true);
    axios
      .post(`marks/allStudentMarks`, payload)
      .then((response) => {
        commit("SET_ALL_STD_MARKS", response.data);
        commit("SET_FETCHING_REPORT_DATA", false);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message:
            "An Error Occurred While. <br/><b>Retrieving Information.</b>",
        };
        commit("pushNotification", message);
        commit("SET_FETCHING_REPORT_DATA", false);
      });
  },
};
